import { ReactNode, useContext } from 'react';
import { SidebarContext } from '@/common/components/sidebar/SidebarContext.ts';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useLingui } from '@lingui/react/macro';

export interface SidebarHeaderProps {
  children?: ReactNode;
}

export const SidebarHeader = ({ children }: SidebarHeaderProps) => {
  const { onClose, id } = useContext(SidebarContext);
  const theme = useTheme();
  const { t } = useLingui();

  return (
    <Stack
      px={2}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      border={1}
      borderColor="divider"
      sx={{ zIndex: 1, backgroundColor: theme.palette.background.paper, ...theme.mixins.toolbar }}
      gap={2}
    >
      <Typography fontWeight={600} component="h2" id={`sidebar-title-${id}`}>
        {children}
      </Typography>
      <IconButton onClick={onClose} aria-label={t`Close`}>
        <CloseIcon data-testid="CloseIcon" />
      </IconButton>
    </Stack>
  );
};
